import { createMachine, DoneInvokeEvent, sendParent } from 'xstate';
import { STATES, ACTIONS, EVENTS } from '../../interfaces/networkInterface';

export const networkMachine = createMachine<{}, DoneInvokeEvent<any>>(
  {
    predictableActionArguments: true,
    id: 'network',
    initial: STATES.READY,
    states: {
      [STATES.READY]: {
        entry: [ACTIONS.SET_CONNECTION],
        on: {
          [EVENTS.CONNECTION_CHANGED]: {
            actions: [ACTIONS.SET_CONNECTION],
          },
        },
        invoke: {
          src: (context) => (callback) => {
            window.addEventListener('online', () => {
              callback({ type: EVENTS.CONNECTION_CHANGED, data: true });
            });
            window.addEventListener('offline', () => {
              callback({ type: EVENTS.CONNECTION_CHANGED, data: false });
            });

            return () => {
              window.removeEventListener('online', () => {
                callback({ type: EVENTS.CONNECTION_CHANGED, data: true });
              });
              window.removeEventListener('offline', () => {
                callback({ type: EVENTS.CONNECTION_CHANGED, data: false });
              });
            };
          },
        },
      },
    },
  },
  {
    actions: {
      [ACTIONS.SET_CONNECTION]: sendParent((_, event) => ({ type: EVENTS.CONNECTION_CHANGED, data: event.data ?? navigator.onLine })),
    },
  },
);
